import { ConfigProvider, Typography } from 'antd';
import Button from 'components/Button';

const FilterPill = ({ label, isSelected, icon, ...props }) => {
  const className = `filter-pill ${isSelected ? 'selected' : ''}`;
  return (
    <ConfigProvider wave={{ disabled: true }}>
      <Button
        block
        className={className}
        trackerLabel={label}
        icon={icon}
        {...props}
      >
        <Typography.Text ellipsis> {label}</Typography.Text>
      </Button>
    </ConfigProvider>
  );
};

export default FilterPill;
